/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import produce from 'immer';

import { FETCH_STATUS } from '../../services/constants';
import {
  actionRequestCountries,
  actionRequestCurrencies,
  actionRequestLegalEntities,
  actionRequestLocales,
} from '../actions/SessionData';

const initialState = {
  locales: {
    value: [],
    status: FETCH_STATUS.NEED_UPDATE,
  },
  countries: {
    value: [],
    status: FETCH_STATUS.NEED_UPDATE,
  },
  legalEntities: {
    value: [],
    status: FETCH_STATUS.NEED_UPDATE,
  },
  currencies: {
    value: [],
    status: FETCH_STATUS.NEED_UPDATE,
  },
};

const SessionData = createReducer(initialState, {
  [actionRequestLocales.pending]: produce((newState) => {
    newState.locales.status = FETCH_STATUS.PENDING;
  }),
  [actionRequestCountries.pending]: produce((newState) => {
    newState.countries.status = FETCH_STATUS.PENDING;
  }),
  [actionRequestLegalEntities.pending]: produce((newState) => {
    newState.legalEntities.status = FETCH_STATUS.PENDING;
  }),
  [actionRequestCurrencies.pending]: produce((newState) => {
    newState.currencies.status = FETCH_STATUS.PENDING;
  }),
  [actionRequestLocales.fulfilled]: produce((newState, { payload }) => {
    newState.locales = {
      value: payload,
      status: FETCH_STATUS.FULFILLED,
    };
  }),
  [actionRequestCountries.fulfilled]: produce((newState, { payload }) => {
    newState.countries = {
      value: payload,
      status: FETCH_STATUS.FULFILLED,
    };
  }),
  [actionRequestLegalEntities.fulfilled]: produce((newState, { payload }) => {
    newState.legalEntities = {
      value: payload,
      status: FETCH_STATUS.FULFILLED,
    };
  }),
  [actionRequestCurrencies.fulfilled]: produce((newState, { payload }) => {
    const now = new Date();

    localStorage.setItem(
      'currencies',
      JSON.stringify({
        data: payload,
        expirationDate: now.setDate(now.getDate() + 30), // updating currencies each month
      }),
    );

    newState.currencies = {
      value: payload,
      status: FETCH_STATUS.FULFILLED,
    };
  }),
});

export default SessionData;
